import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../service/core.service';
import { ApiService } from '../../../service/api.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-update-muti-product',
  templateUrl: './update-muti-product.component.html',
  styleUrls: ['./update-muti-product.component.css']
})
export class UpdateMutiProductComponent implements OnInit {
  fileName = 'Multiple Products.xlsx';

  selecTed: any;
  prd_cat: any;
  catagories: any;
  curpage: any;
  lastpage: any;
  pgend: boolean;
  pgstart: boolean;
  pageFrom: any;
  pageLoadingImg: boolean;
  page_limit: any;
  count: any;
  ErrorMsg: boolean;
  exportLoader: boolean;
  ExpselecTed: any;
  country_dec: string;
  allprdCode: any;
  allEans: any;
  prd_name: any;
  errflag: boolean=false;
  errflag1: boolean=false;
 

  constructor(private apiService: ApiService, private coreService: CoreService) { }

  ngOnInit() {
    this.page_limit = 30;
    this.count = 0;
    this.ErrorMsg = false;


    this.country_dec=this.coreService.setDecimalLength();
    this.apiService.getAllPrdcode().subscribe((res) => {
      this.allprdCode = res.prds
      this.prd_name=res['prds']['prd_name']
      this.allEans=res.eans
      console.log(' this.allEans',  this.prd_name);
      
    });
  }


  searchCat(search: string) {
    const searchval = new FormData();
    searchval.append('cat_name', search);
    this.apiService.getCatbyName(searchval).subscribe((res) => {
      this.catagories = res['data'];
      this.selecTed = null;
    });

  }


  selectCat(cat_id) {
    this.pageNext(cat_id, 1);
  }


  pageNext(cat_id, pageno: any) {
    this.pageLoadingImg = true;

    let searchval = new FormData();
    searchval.append("prd_cat_id", cat_id);
    searchval.append("page_limit", this.page_limit);
    this.apiService.getProdDetByCat(searchval, pageno).subscribe((res: any) => {
      this.pageLoadingImg = false;
      this.selecTed = res['data'];
      this.pageFrom = res['data']['from'];
      this.count = res['data']['count'];


      this.curpage = res['data']['current_page'];
      this.lastpage = res['data']['last_page'];
      this.pgEnd(this.curpage, this.lastpage);
      this.pgStart(this.curpage);

    });
  }

  pgEnd(curr, end) {
    if (curr == end)
      this.pgend = true;
    else
      this.pgend = false;

  }

  pgStart(curr) {
    if (curr == 1)
      this.pgstart = true;
    else
      this.pgstart = false;
  }


  updateProds(product_summary) {

    
    this.errflag = false;
 // Loop through selecTed.data and compare prd_ean with allPrdCode
 this.selecTed.data.forEach((product, index) => {
  let foundInPrdCode = this.allprdCode.find(x => 
    x.prd_code == product.prd_ean && x.prd_id != product.prd_id
);

let foundInAdditionalEans = this.allEans.find(x => 
    x.additional == product.prd_ean && x.prd_id != product.prd_id
);

let foundInPrdBarcode = this.allEans.find(x => 
    x.prd_barcode == product.prd_ean && x.prd_id != product.prd_id
);

   
    
    // Check if product EAN matches and prd_code is not null
    if (foundInPrdCode && foundInPrdCode.prd_code != null) {
        this.errflag = true;
       
      // Find the product name based on the prd_code
    const matchingProduct = this.allprdCode.find(product => product.prd_code === foundInPrdCode.prd_code);

    if (matchingProduct) {
        const errorMessage = `This EAN has already been taken by product: ${matchingProduct.prd_name}`;
        this.selecTed.data[index].error = errorMessage;
    }
    }

    // Check for duplicate EANs in the allEans list, and avoid null values
    else if ((foundInAdditionalEans && foundInAdditionalEans.additional != null) || (foundInPrdBarcode && foundInPrdBarcode.prd_barcode != null)) {
        this.errflag = true;
        console.log('foundInAdditionalEan  '+foundInAdditionalEans);
        console.log('foundInPrdBarcode   '+  foundInPrdBarcode.additional);
        this.selecTed.data[index].error = 'Duplicate EAN within selected data';
    }else{
   
     }
   });
 
  
    
      if(!this.errflag &&!this.errflag1){
        this.pageLoadingImg = true;
    this.apiService.updateMultiProds(product_summary.value).subscribe((res) => {
      this.pageLoadingImg = false;
      if (!res.error) {
        this.ErrorMsg = false;
        this.coreService.showMessage('Updated Successfully');
      }
      else {
        this.ErrorMsg = true;
        this.coreService.showMessage('Error: Unable to update products');
      }
    });
  }
  }
// Method to check for duplicate EANs
checkForDuplicateEan() {
  
  

  this.errflag1 = false;
  const eanSet = new Set();
  this.selecTed.data.forEach((item, index) => {
    // Clear previous errors
    this.selecTed.data[index].error = '';

    // If EAN is already in the set, it's a duplicate
    if (eanSet.has(item.prd_ean)) {
      this.selecTed.data[index].error = 'Duplicate EAN detected';
    } else if (item.prd_ean) {
      eanSet.add(item.prd_ean);
    }


    // Check if EAN is the same as prd_barcode
    const ean = String(item.prd_ean).toLowerCase();
    const code = String(item.prd_code).toLowerCase();
    
    if (ean == code) {
      this.errflag1 = true;
      this.selecTed.data[index].error = 'EAN Barcod and Product Code must not be the same';
    }
  });
 
}

// Trigger validation on EAN input change
onEanChange(index: number) {
  // Check for duplicates after every EAN change
 
  this.checkForDuplicateEan();
}
  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('export-group');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
    this.exportLoader = false;

  }


  exportEXCL(cat_id) {
    this.exportLoader = true;

    // debugger;
    let searchval = new FormData();

    searchval.append("prd_cat_id", cat_id);
    searchval.append("export", 'export');
    this.apiService.getProdDetByCat(searchval, 1).subscribe((res: any) => {
      this.pageLoadingImg = false;
      this.ExpselecTed = res['data'];

      setTimeout(() => {
        this.exportexcel();
      }, 3000);


    });



  }
}
